export default "__VITE_ASSET__86d4bdfc__"